import { render, staticRenderFns } from "./SuperAdminOperatorViewMenu.vue?vue&type=template&id=11dba3a4&scoped=true&lang=pug"
import script from "./SuperAdminOperatorViewMenu.vue?vue&type=script&lang=ts"
export * from "./SuperAdminOperatorViewMenu.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminOperatorViewMenu.vue?vue&type=style&index=0&id=11dba3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dba3a4",
  null
  
)

export default component.exports